import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createBidPackage,
  createEmptyBidPackageLineItem,
  deleteBidPackage,
  deleteEmptyBidPackageLineItem,
  getBidPackageDetail,
  getBidPackageList,
  updateBidPackage,
  updateEmptyBidPackageLineItem,
} from '../../api/constlink';
import gHistory from '../../util/history';
import {
  createBidPackageAsync,
  createEmptyBidPackageLineItemAsync,
  CREATE_BID_PACKAGE,
  CREATE_EMPTY_BID_PACKAGE_LINE_ITEM,
  deleteBidPackageAsync,
  deleteEmptyBidPackageLineItemAsync,
  DELETE_BID_PACKAGE,
  DELETE_EMPTY_BID_PACKAGE_LINE_ITEM,
  getBidPackageDetailAsync,
  getBidPackageListAsync,
  GET_BID_PACKAGE_DETAIL,
  GET_BID_PACKAGE_LIST,
  updateBidPackageAsync,
  updateEmptyBidPackageLineItemAsync,
  UPDATE_BID_PACKAGE,
  UPDATE_EMPTY_BID_PACKAGE_LINE_ITEM,
} from './actions';
import { BidPackage, BidPackageLineItem } from './types';

function* getBidPackageListSaga(
  action: ReturnType<typeof getBidPackageListAsync.request>,
) {
  try {
    const bidPackages: BidPackage[] = yield call(
      getBidPackageList,
      action.payload,
    );
    yield put(getBidPackageListAsync.success(bidPackages));
  } catch (e: any) {
    yield put(getBidPackageListAsync.failure(e));
  }
}

function* createBidPackageSaga(
  action: ReturnType<typeof createBidPackageAsync.request>,
) {
  try {
    const bidPackage: BidPackage = yield call(createBidPackage, action.payload);
    yield put(createBidPackageAsync.success(bidPackage));
    gHistory.goBack();
  } catch (e: any) {
    yield put(createBidPackageAsync.failure(e));
  }
}

function* updateBidPackageSaga(
  action: ReturnType<typeof updateBidPackageAsync.request>,
) {
  try {
    const bidPackage: BidPackage = yield call(updateBidPackage, action.payload);
    yield put(updateBidPackageAsync.success(bidPackage));
  } catch (e: any) {
    yield put(updateBidPackageAsync.failure(e));
  }
}

function* deleteBidPackageSaga(
  action: ReturnType<typeof deleteBidPackageAsync.request>,
) {
  try {
    const bidPackageId: number = yield call(deleteBidPackage, action.payload);
    yield put(deleteBidPackageAsync.success(bidPackageId));
  } catch (e: any) {
    yield put(deleteBidPackageAsync.failure(e));
  }
}

function* getBidPackageDetailSaga(
  action: ReturnType<typeof getBidPackageDetailAsync.request>,
) {
  try {
    const bidPackage: BidPackage = yield call(
      getBidPackageDetail,
      action.payload,
    );
    yield put(getBidPackageDetailAsync.success(bidPackage));
  } catch (e: any) {
    yield put(getBidPackageDetailAsync.failure(e));
  }
}

/*
function* createBidPackageLineItemSaga(
  action: ReturnType<typeof createBidPackageLineItemAsync.request>,
) {
  try {
    const bidPackage: BidPackage = yield call(
      createBidPackageLineItem,
      action.payload,
    );
    yield put(createBidPackageLineItemAsync.success(bidPackage));
  } catch (e: any) {
    yield put(createBidPackageLineItemAsync.failure(e));
  }
}

function* deleteBidPackageLineItemSaga(
  action: ReturnType<typeof deleteBidPackageLineItemAsync.request>,
) {
  try {
    yield call(deleteBidPackageLineItem, action.payload);
    yield put(deleteBidPackageLineItemAsync.success(action.payload.id));
  } catch (e: any) {
    yield put(deleteBidPackageLineItemAsync.failure(e));
  }
}
*/

function* createEmptyBidPackageLineItemSaga(
  action: ReturnType<typeof createEmptyBidPackageLineItemAsync.request>,
) {
  try {
    const bidPackageLineItems: BidPackageLineItem[] = yield call(
      createEmptyBidPackageLineItem,
      action.payload,
    );
    yield put(createEmptyBidPackageLineItemAsync.success(bidPackageLineItems));
  } catch (e: any) {
    yield put(createEmptyBidPackageLineItemAsync.failure(e));
  }
}

function* updateEmptyBidPackageLineItemSaga(
  action: ReturnType<typeof updateEmptyBidPackageLineItemAsync.request>,
) {
  try {
    const bidPackageLineItems: BidPackageLineItem[] = yield call(
      updateEmptyBidPackageLineItem,
      action.payload,
    );
    yield put(updateEmptyBidPackageLineItemAsync.success(bidPackageLineItems));
  } catch (e: any) {
    yield put(updateEmptyBidPackageLineItemAsync.failure(e));
  }
}

function* deleteEmptyBidPackageLineItemSaga(
  action: ReturnType<typeof deleteEmptyBidPackageLineItemAsync.request>,
) {
  try {
    yield call(deleteEmptyBidPackageLineItem, action.payload);
    yield put(deleteEmptyBidPackageLineItemAsync.success(null));
  } catch (e: any) {
    yield put(deleteEmptyBidPackageLineItemAsync.failure(e));
  }
}

export function* bidPackagesSaga() {
  yield takeLatest(GET_BID_PACKAGE_LIST, getBidPackageListSaga);
  yield takeLatest(CREATE_BID_PACKAGE, createBidPackageSaga);
  yield takeLatest(UPDATE_BID_PACKAGE, updateBidPackageSaga);
  yield takeLatest(DELETE_BID_PACKAGE, deleteBidPackageSaga);
  yield takeLatest(
    CREATE_EMPTY_BID_PACKAGE_LINE_ITEM,
    createEmptyBidPackageLineItemSaga,
  );
  yield takeLatest(
    UPDATE_EMPTY_BID_PACKAGE_LINE_ITEM,
    updateEmptyBidPackageLineItemSaga,
  );
  yield takeLatest(
    DELETE_EMPTY_BID_PACKAGE_LINE_ITEM,
    deleteEmptyBidPackageLineItemSaga,
  );
  yield takeLatest(GET_BID_PACKAGE_DETAIL, getBidPackageDetailSaga);
}
